import React, { useCallback, useEffect, useState } from "react";
import Loader from "../../../../../components/Loader";
import SlideUpWrapper from "../../../../../components/Transitions/SlideUpWrapper";
import Icon from "react-icons-kit";
import { androidArrowBack } from "react-icons-kit/ionicons/androidArrowBack";
import styles from "./RequestDetails.module.css";
import { _ToNormal, setDate } from "../../../../../Utils/helper";
import { useNavigate, useParams } from "react-router-dom";
import API from "../../../../../ApiConfig";
import {
  CREATE_WA_APPEAL,
  GET_WA_APPEAL_METADATA,
} from "../../../../../Utils/constant";
import cogoToast from "cogo-toast-react-17-fix";
import { useSelector } from "react-redux";
const WACreateAppeal = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const [submitloading, setSubmitLoading] = useState(false);
  const { verification_request_id } = useParams();

  const [data, setData] = useState(null);
  const [fieldsData, setFieldsData] = useState([]);

  const User = useSelector((state) => state.User);
  const getWaAppeal = () => {
    setLoading(true);

    API.get(GET_WA_APPEAL_METADATA + verification_request_id)
      .then((res) => {
        if (res.data.status == 200) {
          setLoading(false);
          setData(res.data.data);
          setFieldsData(res.data.data.fields);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getWaAppeal();
  }, []);
  const [comment, setComment] = useState("");
  const [file, setFile] = useState("");
  const validateFieldData = () => {
    let isValid = true;
    if (!fieldsData.some((field) => field.value && field.value.trim() !== "")) {
      isValid = false;
      cogoToast.error("enter data to raise appeal");
    } else if (!file) {
      isValid = false;
      cogoToast.error("Please add file to procced ");
    } else if (comment.trim() == "") {
      isValid = false;
      cogoToast.error("Please give some remarks");
    } else {
      for (let item of fieldsData) {
        if (item.value && item.regex[0]) {
          const pattern = new RegExp(item.regex[0]);
          if (!pattern.test(item.value)) {
            isValid = false;
            cogoToast.error(
              `Invalid new value enter for ${_ToNormal(item.field_name)}`
            );
          }
        }
      }
    }
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateFieldData()) {
      return;
    } else {
      const requestedFields = {};
      fieldsData.forEach((item) => {
        if (item.value !== "" && item.checked) {
          requestedFields[item.id] = item.value;
        }
      });
      const formdata = new FormData();
      formdata.append("verifier_id", User.id);
      formdata.append("verifier_payload", JSON.stringify(requestedFields));
      formdata.append("verification_request_id", verification_request_id);
      formdata.append("verifier_remarks", comment);
      formdata.append("supporting_document_upload", file);
      setSubmitLoading(true);
      API.post(CREATE_WA_APPEAL, formdata)
        .then((res) => {
          setSubmitLoading(false);
          if (res.data.status == 201) {
            navigate("/dashboard/emp/requests");
          }
        })

        .catch((err) => {
          setSubmitLoading(false);

          cogoToast.error(
            err.response?.data?.detail[0] || "Something went wrong"
          );
        });
    }
  };

  const handleChange = useCallback((id, value) => {
    setFieldsData((prev) =>
      prev.map((field) => (field.id === id ? { ...field, value } : field))
    );
  }, []);
  const handleBlur = useCallback((id, value) => {
    setFieldsData((prev) =>
      prev.map((fields) =>
        fields.id === id ? { ...fields, value: value.trim() } : fields
      )
    );
  },[])
  const handleCheckBox = (id, checked) => {
    setFieldsData((prev) =>
      prev.map((fields, i) =>
        fields.id === id ? { ...fields, checked, value: "" } : fields
      )
    );
  };

  return (
    <div style={{ width: "100%" }}>
      <Loader isOpen={loading || submitloading} />
      <SlideUpWrapper direction="slide-left">
        <div>
          <h2 className={styles.header}>
            <Icon
              icon={androidArrowBack}
              size={"1.2rem"}
              onClick={() => navigate(`../emp/requests`)}
              style={{ cursor: "pointer" }}
            />
            {loading ? (
              <div className="shimmer" style={{ width: "10rem" }} />
            ) : (
              "Create Appeal"
            )}
          </h2>
          <div className={styles.section}>
            <div className={styles.mainContainer}>
              <div className={styles.tableHeader}>
                <h3 className="heading">
                  {loading ? (
                    <div className="shimmer" style={{ width: "10rem" }} />
                  ) : (
                    `Employee Name: ${data?.name}`
                  )}
                </h3>
                <div className={styles.basicDetails}>
                  {data?.appeal_raised_on !== null && (
                    <div>
                      <span className="heading">Appeal Raised on</span>
                      <span>
                        {loading ? (
                          <div className="shimmer" style={{ width: "10rem" }} />
                        ) : (
                          setDate(data?.appeal_raised_on)
                        )}
                      </span>
                    </div>
                  )}
                  {data?.appeal_raised && (
                    <div>
                      <span className="heading">Appeal Status</span>
                      <span>
                        {loading ? (
                          <div className="shimmer" style={{ width: "10rem" }} />
                        ) : (
                          <div
                            className={`${
                              data?.status === "PENDING_ON_ISSUER"
                                ? "Pending"
                                : data?.status == "DENIED"
                                ? "Rejected"
                                : "Complete"
                            }`}
                            style={{ width: "auto", height: "auto" }}
                          >
                            {_ToNormal(data?.status)}
                          </div>
                        )}
                      </span>
                    </div>
                  )}
                </div>
              </div>
              {data?.status === "PENDING_ON_ISSUER" ||
              data?.status === "DENIED" ||
              data?.status === null ? (
                <div>
                  <table style={{ width: "100%", textAlign: "left" }}>
                    <tbody>
                      {fieldsData &&
                        fieldsData.map((item, index) => (
                          <tr
                            key={index}
                            className="credentials-header1"
                            style={{ alignItems: "center" }}
                          >
                            <td
                              key={index}
                              className="credentials-header1"
                              style={{ alignItems: "center" }}
                            >
                              <td
                                className="credentials-td"
                                style={{
                                  justifyContent: "flex-start",
                                  width: "15rem",
                                }}
                              >
                                {_ToNormal(item.field_name)}
                              </td>
                            </td>

                            <td
                              key={index}
                              className="credentials-header1"
                              style={{ alignItems: "center" }}
                            >
                              <td
                                className="credentials-td"
                                style={{
                                  justifyContent: "flex-start",
                                  width: "15rem",
                                }}
                              >
                                {/* <input type="checkbox" className={styles.input} checked={item.checked} onChange={(e)=>handleCheckBox(item.id,e.target.checked)}/>  */}
                                {item.field_name=="Employee Id"?null:
                                <div className="checkbox-wrapper-22">
                                  <label
                                    className="switch"
                                    htmlFor={`checkbox ${item.id}`}
                                  >
                                    <input
                                      type="checkbox"
                                      id={`checkbox ${item.id}`}
                                      checked={item.checked}
                                      onChange={(e) =>
                                        handleCheckBox(
                                          item.id,
                                          e.target.checked
                                        )
                                      }
                                      disabled={data?.appeal_raised}
                                    />
                                    <div className="slider round"></div>
                                  </label>
                                </div>}
                              </td>
                            </td>
                            <td
                              key={index}
                              className="credentials-header1"
                              style={{ alignItems: "center" }}
                            >
                              <td
                                className="credentials-td"
                                style={{
                                  justifyContent: "flex-start",
                                  width: "15rem",
                                }}
                              >
                                {" "}
                                <input
                                  type="text"
                                  className={styles.input}
                                  value={item.value}
                                  onChange={(e) =>
                                    handleChange(item.id, e.target.value)
                                  }
                                  onBlur={(e) => handleBlur(item.id, e.target.value)}
                                  placeholder={item.placeholder}
                                  disabled={
                                    !item.checked || data?.appeal_raised
                                  }
                                />{" "}
                              </td>
                            </td>
                          </tr>
                        ))}
                       <tr
                            className="credentials-header1"
                            style={{ alignItems: "center" }}
                          >
                            <td
                              className="credentials-header1"
                              style={{ alignItems: "center" }}
                            >
                              <td
                                className="credentials-td"
                                style={{
                                  justifyContent: "flex-start",
                                  width: "15rem",
                                }}
                              >
                            {" "}
                            {`Please upload the supporting document for adding details (Service Letter, Experience Letter)`}
                          </td>
                        </td>
                        <td
                          className="credentials-header1"
                          style={{
                            width: "15rem",
                          }}
                        ></td>
                        <td
                          className="credentials-header1"
                          style={{alignItems:"center" }}
                        >
                          {data?.appeal_raised ? null : (
                            <td className="credentials-td" style={{width:"15rem"}}>
                              <input
                                type="file"
                                onChange={(e) => setFile(e.target.files[0])}
                                accept=".pdf"
                                style={{width:"100%"}}
                              />
                            </td>
                          )}
                        </td>
                      </tr>
                      <tr
                        className="credentials-header1"
                        style={{ alignItems: "center" }}
                      >
                        <td
                          className="credentials-header1"
                          style={{ alignItems:"center"}}
                        >
                          <td className="credentials-td" style={{width:"15rem"}}>
                            Please share your comments/remarks
                          </td>
                        </td>
                        <td
                          className="credentials-header1"
                          style={{
                            width: "15rem",
                          }}
                        ></td>
                        <td
                          className="credentials-header1"
                        >
                          <td className="credentials-td" style={{width:"15rem"}}>
                            <textarea
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                              className={styles.AppealComment}
                              placeholder="Enter Comment"
                              disabled={data?.appeal_raised}
                              title="Verifier Remarks"
                            />
                          </td>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {data?.appeal_raised ? null : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginTop: "10px",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={(e) => handleSubmit(e)}
                        disabled={data?.appeal_raised}
                      >
                        {submitloading ? "Submitting..." : "Create Appeal"}
                      </button>
                    </div>
                  )}
                </div>
              ) : loading ? (
                <div className="shimmer" style={{ width: "10rem" }}></div>
              ) : (
                <table style={{ width: "100%", textAlign: "left" }}>
                  <tbody>
                    <tr
                      className="credentials-header1"
                      style={{ alignItems: "center" }}
                    >
                      <td
                        className="credentials-td"
                        style={{
                          justifyContent: "flex-start",
                          maxWidth: "10rem",
                        }}
                      >
                        New Document
                      </td>
                      <td
                        className="credentials-td"
                        style={{ justifyContent: "flex-start" }}
                      >
                        {data?.new_issued_document_full_pdf ? (
                          <button
                            className="btn btn-secondary"
                            onClick={(e) =>
                              setPreview(
                                data?.new_issued_document_full_pdf
                                  ? data?.new_issued_document_full_pdf
                                  : null
                              )
                            }
                            style={{
                              display: "flex",
                              gap: "0.3rem",
                              textDecoration: "none",
                            }}
                          >
                            <img
                              className={styles.downloadOutlineIcon}
                              alt=""
                              src="/downloadoutline.svg"
                            />
                            View PDF
                          </button>
                        ) : (
                          "Document Link Expired"
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </SlideUpWrapper>
    </div>
  );
};

export default WACreateAppeal;
